<script lang="ts">
	import type { Props } from "@components/inputs/Button.svelte";
	import Button from "@components/inputs/Button.svelte";
	import ArrowBackIOS from "@svg/ArrowBackwardIOS.svelte";
	import { navigate } from "astro:transitions/client";

	export let title = "";
	export let keepOnPageHref = "";
	export let buttonProps: Props | null = null;
</script>

<Button
	textColor="text-black"
	css="pl-0 font-medium !text-base"
	variant="btn-text"
	onclick={() => {
		let params = new URL(window.location.href).searchParams;

		const overwriteBackbutton = params.get("overwriteBackbutton");

		if (overwriteBackbutton) {
			navigate(overwriteBackbutton);
			return;
		}

		if (history.state?.index === 0 || history.state?.index === "NaN") {
			if (keepOnPageHref) {
				navigate(keepOnPageHref);
				return;
			}
		}

		history.back();
	}}
	{...buttonProps}
>
	<ArrowBackIOS class="mr-2 h-5 w-5 fill-current" />
	{title}
	<slot />
</Button>
